import { render } from "./ActivatedMenu.vue?vue&type=template&id=17f48ff9"
import script from "./ActivatedMenu.vue?vue&type=script&lang=js"
export * from "./ActivatedMenu.vue?vue&type=script&lang=js"

import "./ActivatedMenu.vue?vue&type=style&index=0&id=17f48ff9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__